import styled from 'styled-components';

const StyledMenuContainer = styled.div`
	position: relative;
	width: 100%;
	height: 40px;
	display: flex;
	gap: 20px;
	user-select: none;

	&::after {
		content: '';
		box-sizing: content-box !important;
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 1px;
		opacity: 0.1;
		background-color: white;
	}
`;

const StyledTabButton = styled.div`
	position: relative;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	flex-grow: 0;
	border-radius: 6px;
	background-color: #fff;

	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	font-weight: bold;
	color: #000;
`;

export { StyledMenuContainer, StyledTabButton };
